<template>
  <svg
    class="custom-icon"
    width="40"
    height="54"
    viewBox="0 0 40 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.293 27.3295C15.6835 26.8902 16.3167 26.8902 16.7072 27.3295L24.7072 36.3295C24.9932 36.6512 25.0788 37.1351 24.924 37.5555C24.7692 37.9759 24.4046 38.25 24.0001 38.25H19.0001V52.875C19.0001 53.4963 18.5524 54 18.0001 54H14.0001C13.4478 54 13.0001 53.4963 13.0001 52.875V38.25H8.00005C7.59555 38.25 7.23095 37.9759 7.07615 37.5555C6.92135 37.1351 7.00695 36.6512 7.29295 36.3295L15.293 27.3295Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.05714 0H2C0.895431 0 0 0.967066 0 2.16V4.18776H2V2.16L4.05714 2.16V0ZM0 49.8122V51.84C0 53.0329 0.895431 54 2 54H4.05714V51.84H2L2 49.8122H0ZM0 46.7706H2V42.7151H0V46.7706ZM0 39.6735H2V35.618H0V39.6735ZM0 32.5763H2V28.5208H0V32.5763ZM0 25.4792H2V21.4237H0V25.4792ZM0 18.382H2V14.3265H0V18.382ZM0 11.2849H2V7.22939H0V11.2849ZM7.14286 0V2.16H11.2571V0H7.14286ZM14.3429 0V2.16H18.4571V0H14.3429ZM21.5429 0V2.16H25.6571V0H21.5429ZM40 14.3265H38V18.382H40V14.3265ZM40 21.4237H38V25.4792H40V21.4237ZM40 28.5208H38V32.5763H40V28.5208ZM40 35.618H38V39.6735H40V35.618ZM40 42.7151H38V46.7706H40V42.7151ZM40 49.8122H38V51.84H35.9429V54H38C39.1046 54 40 53.0329 40 51.84V49.8122ZM32.8571 54V51.84H28.7429V54H32.8571ZM25.6571 54V51.84H23V54H25.6571ZM9.5 54V51.84H7.14286V54H9.5Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.9998 5.40016L26.9139 3.14735L28.3281 1.62L30.4141 3.87281L28.9998 5.40016ZM32.7498 9.45016L30.2498 6.75016L31.6641 5.22281L34.1641 7.92281L32.7498 9.45016ZM36.0858 13.053L33.9998 10.8002L35.4141 9.27281L37.5 11.5256L36.0858 13.053Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.0571 17.3021H25C23.8954 17.3021 23 16.3351 23 15.1421V13.1144H25V15.1421L27.0571 15.1421V17.3021ZM23 6.01725H25V10.0728H23V6.01725ZM30.1429 17.3021V15.1421H34.2571V17.3021H30.1429Z"
    />
  </svg>
</template>
